/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import Switch from '@material-ui/core/Switch';
import { StyledTableCell } from './StyledTableCell';

export function FeeSwitchCell({ checked, disabled, onChange }) {
  return (
    <StyledTableCell>
      <Switch color="primary" checked={checked} disabled={disabled} onChange={onChange} />
    </StyledTableCell>
  );
}
